/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
import React from 'react';
import { RouteComponentProps, matchPath } from 'react-router-dom';
import { PageNotFound } from 'shared/components';
import { Container } from './Styles';
import CreateCompany from './CreateCompany';
import EditCompany from './EditCompany';

const CompanyDetail: React.FC<RouteComponentProps> = (props) => {
  const { location } = props;

  let content = <PageNotFound />;

  const matchPage = (path: string) => {
    return !!matchPath(location.pathname, path);
  };

  if (matchPage(`/setting/creditor/company/create`)) {
    content = <CreateCompany />;
  } else if (matchPage(`/setting/creditor/company/edit`)) {
    content = <EditCompany />;
  }

  return <Container>{content}</Container>;
};

export default CompanyDetail;
